export default "__VITE_ASSET__8a306893__"